import {DeepPartial} from 'utility-types';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {SeriesResponseBody, SeriesType} from '@dms/api/core';
import {GetServiceOrderVariantDocumentsApiResponse} from '@dms/api/workshop';

import {Nullish} from 'shared/web';

import {FormType} from '../types/ServiceOrderVariant';
import {getSoleSeriesId} from './getSoleSeriesId';

type Series = Pick<SeriesResponseBody, 'id' | 'type'>[] | Nullish;

// Prefills here rather than in the Documents tab because only the active tab is mounted. Rows whose
// visibility depends on available-documents stay in the tab, which is the only place that knows it.
export function buildDocumentsDefaultValues(
  documents: GetServiceOrderVariantDocumentsApiResponse | Nullish,
  series: Series
): DeepPartial<FormType>['documents'] {
  const resolveDocSeriesId = (docSeriesId: string | Nullish, type: SeriesType) =>
    (isNotNilOrEmpty(docSeriesId) ? docSeriesId : getSoleSeriesId(series, type)) ?? undefined;

  const isFastTrackEnabled = documents?.fastTrackIssue?.isEnable ?? false;

  return {
    ...documents,
    serviceOrderIssue: {
      ...documents?.serviceOrderIssue,
      docSeriesId: resolveDocSeriesId(
        documents?.serviceOrderIssue?.docSeriesId,
        'workshop/service_order_issue'
      ),
    },
    serviceOrderReturn: {
      ...documents?.serviceOrderReturn,
      docSeriesId: resolveDocSeriesId(
        documents?.serviceOrderReturn?.docSeriesId,
        'workshop/service_order_parts_return'
      ),
    },
    fastTrackIssue: {
      ...documents?.fastTrackIssue,
      isEnable: isFastTrackEnabled,
      // Only required while enabled, so filling it when off would store a value nobody can see.
      docSeriesId: isFastTrackEnabled
        ? resolveDocSeriesId(documents?.fastTrackIssue?.docSeriesId, 'warehouse/fast-track')
        : (documents?.fastTrackIssue?.docSeriesId ?? undefined),
    },
    order: {
      ...documents?.order,
      isUniqueDocSeries: documents?.order?.isUniqueDocSeries ?? false,
      docSeriesId: documents?.order?.docSeriesId ?? undefined,
    },
  };
}
